
import axios from "axios"
import router from '../../router';

import { func } from '../../main';

const state = {
    InviteUserList: [],
    Loading:false
};


const getters = {
    GetInviteUserList(state: { InviteUserList: any; }) {
        return state.InviteUserList;
    }
};

const mutations = {

    SetInviteUserList(state: { InviteUserList: any; }, list: any) {
        state.InviteUserList = list;
    }

};

const actions = {
    GetInviteUserListFromServer(context: { commit: (arg0: string, arg1: any) => void; }) {
        axios.get("InviteUser/GetList", {
        })
            .then((data: any) => {
                context.commit("SetInviteUserList", data.data);
            });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};
